'use strict';

var defaults = require('../../defaults/Defaults');
var log = require('../../log/Log').channel('LanguageService');
var moment = require('moment');
// load supported locales for moment.js
require('../node_modules/moment/locale/en-gb.js');
require('../node_modules/moment/locale/fr.js');
require('../node_modules/moment/locale/x-pseudo.js');

angular.module('inara').factory('LanguageService', LanguageService);

LanguageService.$inject = ['$ionicHistory', 'gettextCatalog', '$q'];

function LanguageService($ionicHistory, gettextCatalog, $q) {
    var languages = [
        { code: 'en', momentCode: 'en', label: 'English (US)', builtIn: true },
        { code: 'en-gb', momentCode: 'en-gb', label: 'English (UK)' },
        { code: 'fr', momentCode: 'fr', label: 'Français' }
    ];
    if (process.env.build === 'debug') {
        languages.push(
            { code: 'x-piglatin', momentCode: 'x-pseudo', label: 'Oink' });
    }

    var deviceDriverTranslations;
    createDeviceDriverTranslations();

    // TODO: remove this when we support user's language in the browser
    if (process.env.appEnv === 'browser') {
        setLanguage('en');
    }

    log.debug('initializing LanguageService');

    return {
        getDeviceDriverTranslation: getDeviceDriverTranslation,
        getLanguages: getLanguages,
        setLanguage: setLanguage
    };

    function createDeviceDriverTranslations() {
        deviceDriverTranslations = {
            /// Zoom sharing label
            'iPhone/iPad/Mac': gettextCatalog.getString('iPhone/iPad/Mac'),
            /// Zoom sharing label
            'Laptop': gettextCatalog.getString('Laptop'),
            /// Zoom sharing description (for 'iPhone/iPad/Mac')
            'Using AirPlay': gettextCatalog.getString('Using AirPlay'),
            /// Zoom sharing description (for 'Laptop' when shared with HDMI cable)
            'Using Cable': gettextCatalog.getString('Using Cable'),
            /// Zoom sharing description (for 'Laptop' when shared with Zoom App)
            'Using Zoom App/Browser': gettextCatalog.getString('Using Zoom App/Browser'),
            /// Zoom sharing description (for main Zoom meeting)
            'Zoom Meeting': gettextCatalog.getString('Zoom Meeting')
        };
    }

    function getDeviceDriverTranslation(msgId) {
        if (deviceDriverTranslations.hasOwnProperty(msgId)) {
            return deviceDriverTranslations[msgId];
        }
        log.error('No device driver translation found for: ' + msgId);
        return msgId;
    }

    function getLanguages() {
        return languages;
    }

    function setLanguage(language) {
        var languages = getLanguages();
        var foundLang = languages.find(function(el) {
            return el.code === language;
        });
        if (!foundLang) {
            log.warning('Could not find selected language: ' + language);
            log.warning('Falling back to default language: ' + defaults.inara.language);
            foundLang = languages.find(function(el) {
                return el.code === defaults.inara.language;
            });
        }
        if (foundLang) {
            moment.locale(foundLang.hasOwnProperty('momentCode') ? 
                foundLang.momentCode : foundLang.code);
            var langLoaded = $q.resolve();
            if (!foundLang.builtIn) {
                langLoaded = gettextCatalog.loadRemote('./translations/' + foundLang.code + '.json');                    
            }
            langLoaded.then(function() {
                // clear Ionic's view cache so cached views will get re-rendered
                $ionicHistory.clearCache().then(function() {
                    gettextCatalog.setCurrentLanguage(foundLang.code);
                    createDeviceDriverTranslations();
                });
            }).catch(function() {
                log.error('Could not load language: ' + foundLang.code);
            });
        } else {
            log.error('Could not fall back to default language');
        }
    }
}

module.exports = LanguageService;